/*
 *   Copyright (c) 2021 Youra Leangseng
 *   All rights reserved.
 */
import React from "react";
import {CButton} from "@coreui/react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Searching from "../Searching";

// import CIcon from "@coreui/icons-react";

const HotButton = ({ value , icon, onClick, readOnly, selected, loading, noBorder = false}) => {
  return(
    <>
      {
        loading && (
          <>
            <Searching animation="border" variant="warning" size="sm"/>
          </>
        )
      }
      <CButton active={selected} className={` btn ${noBorder ? '' :'btn-outline-dark'} btn-sm`} onClick={onClick} disabled={readOnly ?? false}>
        {icon ? <FontAwesomeIcon icon={icon} /> : ''} {value ? value : ''}
      </CButton>
    </>
  )
}
export default HotButton
